module.exports = __webpack_public_path__ + "static/media/applicant_manager.2e57c4c4.svg";